import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    tokenemanuel: "",
    adminemanuel: []
  },
  mutations: {
    login(state, data) {
      state.adminemanuel = data.user;
      state.tokenemanuel = data.token;
    },
    logout(state) {
      state.sesion = [];
      state.adminemanuel = [];
      state.tokenemanuel = "";
    },
    adminemanuel(state, data) {
      state.adminemanuel = data;
    }
  },
  actions: {
    login({ commit }, data) {
      commit("login", data);
    },
    logout({ commit }) {
      commit("logout");
    },
    setuser({ commit }, data) {
      commit("adminemanuel", data);
    }
  }
});
